import React from 'react';
import { LuPencil, LuTrash2 } from 'react-icons/lu';
import formatBRL from '../../../shared/utils/formatBRL';
import './CouponTable.css';

const benefitLabel = (coupon) => {
  if (coupon.type === 'delivery') {
    return {
      title: coupon.discount === 100 ? 'Frete grátis' : `${coupon.discount}% OFF`,
      subtitle: `${coupon.discount}% de desconto no frete`,
    };
  }
  return { title: `${coupon.discount}% OFF`, subtitle: 'em produtos' };
};

const CouponTable = ({ coupons, perCoupon, onEdit, onDelete }) => {
  if (!coupons || coupons.length === 0) {
    return <p className="text-muted mb-0">Nenhum cupom encontrado.</p>;
  }

  return (
    <div className="coupon-table-wrapper">
      <table className="coupon-table">
        <thead>
          <tr>
            <th>Código</th>
            <th>Benefício</th>
            <th>Aplicável a</th>
            <th>Utilização (período)</th>
            <th>Vendas geradas</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {coupons.map((coupon) => {
            const benefit = benefitLabel(coupon);
            const couponStats = perCoupon?.[coupon.code];
            return (
              <tr key={coupon._id}>
                <td className="coupon-table__code">{coupon.code}</td>
                <td>
                  <div className="coupon-table__benefit">
                    <strong>{benefit.title}</strong>
                    <span className="text-muted">{benefit.subtitle}</span>
                  </div>
                </td>
                <td className="text-muted">Todos os produtos</td>
                <td>
                  {couponStats?.uses ?? 0} <span className="text-muted">usos</span>
                </td>
                <td>{formatBRL(couponStats?.revenue ?? 0)}</td>
                <td>
                  <span className={`coupon-badge ${coupon.enabled ? 'coupon-badge--active' : 'coupon-badge--inactive'}`}>
                    {coupon.enabled ? 'Ativo' : 'Inativo'}
                  </span>
                </td>
                <td className="coupon-table__actions">
                  <button type="button" className="coupon-table__icon-btn" aria-label={`Editar ${coupon.code}`} onClick={() => onEdit(coupon)}>
                    <LuPencil size={16} />
                  </button>
                  <button type="button" className="coupon-table__icon-btn coupon-table__icon-btn--danger" aria-label={`Excluir ${coupon.code}`} onClick={() => onDelete(coupon)}>
                    <LuTrash2 size={16} />
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CouponTable;
